"use client";
import { useUserAuth } from "@/lib/hooks/useUserAuth";
import { useLocale, useTranslations } from "next-intl";
import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { Controller, useForm } from "react-hook-form";
import { GETAddresscountryArea } from "@/lib/api/user";
import { useUserStore } from "@/store/user.store";
import { isValidPhoneNumber, parsePhoneNumber } from "libphonenumber-js";
import PhoneInput from "react-phone-input-2";
import { RingLoader } from "react-spinners";
import axios from "axios";
import { header, shippingTitle } from "@/lib/utils/util";
import { getRegionJson } from "@/lib/api/region";

// 定义省份/地区选项的接口
interface CountryAreaItem {
	verbose?: string;
	raw?: string;
	__typename?: string;
}

export default function VisitorAddress({ setactiveshipping }) {
	let [Address, setAddress] = useState(null);

	const [countries, setcountries] = useState([]);
	//省
	const [countryArea, setcountryArea] = useState<CountryAreaItem[]>([]);
	const [loading, setLoading] = useState(false);

	const [userShipping, setUserShipping] = useState();
	const t = useTranslations();
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		formState: { errors, isValid },
		getValues: getFormValues,
		control,
		watch,
	} = useForm({
		mode: "onBlur",
	});

	let locale = useLocale();

	useEffect(() => {
		// 组件加载时自动获取国家列表
		getCountries();
	}, []);

	//获取国家
	async function getCountries() {
		let { data } = await axios.post(
			`${process.env.NEXT_PUBLIC_AI_URL}/api/v1/ml_web/get_translate_country_json?language_code=${locale}`,
			{
				header,
			},
		);
		if (data.code == 200) {
			// 使用 shift() 方法删除数组第一项
			const countryList = [...data.result.country];
			countryList.shift();
			setcountries(countryList);
		}
	}

	const handleChangeCountry = async (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedCountry = e.target.value;
		console.log("选择的国家:", selectedCountry);

		// 先检查是否有选择国家
		if (!selectedCountry) {
			setcountryArea([]);
			return;
		}

		// 设置加载状态
		setLoading(true);
		setValue("country", selectedCountry); // 确保country值已更新

		try {
			// 尝试使用两种方式获取省份数据
			try {
				// 方法1: 使用GETAddresscountryArea API
				const response = await GETAddresscountryArea(selectedCountry, null);
				console.log("GETAddresscountryArea 响应:", response);

				// 检查响应是否存在并包含所需数据
				if (
					response &&
					response.addressValidationRules &&
					response.addressValidationRules.countryAreaChoices &&
					response.addressValidationRules.countryAreaChoices.length > 0
				) {
					// 使用可选链和默认空数组，防止意外的undefined值
					const choices = response.addressValidationRules.countryAreaChoices || [];
					setValue("addressValidationRules", response.addressValidationRules);
					setcountryArea(choices);
					console.log("设置省份数据(方法1):", choices);

					// 当国家变更时，清空之前选择的省份值
					setValue("countryArea", "");
					setLoading(false);
					return; // 成功获取数据，退出函数
				} else {
					console.warn("GraphQL API返回的省份数据为空，尝试备用方法");
				}
			} catch (error) {
				console.warn("GraphQL API获取省份数据失败，尝试备用方法", error);
			}

			// 方法2: 尝试使用区域API作为备用
			try {
				const regions = await getRegionJson(selectedCountry, locale);
				console.log("备用API返回的区域数据:", regions);

				if (regions && regions.length > 0) {
					// 转换为所需格式
					const formattedRegions = regions.map((region) => ({
						verbose: region.name,
						raw: region.isoCode,
						__typename: "CountryAreaType",
					}));

					setcountryArea(formattedRegions);
					console.log("设置省份数据(备用方法):", formattedRegions);
					setValue("countryArea", "");
				} else {
					console.error("两种方法都无法获取省份数据");
					setcountryArea([]);
				}
			} catch (error) {
				console.error("备用API获取省份数据失败", error);
				setcountryArea([]);
			}
		} catch (error) {
			console.error("获取省份数据出错：", error);
			setcountryArea([]);
		} finally {
			setLoading(false);
		}
	};

	// 监听表单值变化
	useEffect(() => {
		const subscription = watch((value: any) => {
			// 检查所有必填字段是否都已填写
			if (
				value.firstName &&
				value.lastName &&
				value.country &&
				value.city &&
				value.streetAddress1 &&
				value.postalCode &&
				value.phone &&
				value.email
			) {
				onsubmit(value);
			}
		});
		return () => subscription.unsubscribe();
	}, [watch]);

	//提交 创建or修改
	const onsubmit = async (data: any) => {
		// 直接从表单中获取所有数据，确保一致性
		const country = getFormValues("country");
		console.log("获取到的国家值:", country);

		// 构建完整的表单数据
		let Formdata = {
			...getFormValues(),
			phone: `+${data.phone}`,
			// 强制确保country字段存在
			country: country,
		};

		if (!Formdata.country) {
			console.error("国家信息缺失，请检查表单!");
			alert("请选择国家！");
			return;
		}

		console.log("提交的地址信息:", Formdata);
		setAddress(Formdata);
		setactiveshipping(Formdata);
	};

	return (
		<div className="border-r border-gray-200 bg-white p-6">
			{Address && (
				<div className="mb-4 rounded-md    p-3">
					<div className="flex flex-col gap-2">
						<div className="flex items-center gap-2">
							<div className="text-lg font-semibold text-main">
								{Address.firstName} {Address.lastName}
							</div>
						</div>
						<div className="text-sm text-gray-700">
							<div className="mb-2">
								{Address.companyName} {Address.streetAddress1}
							</div>
							<div className="mb-2">
								{[Address.city, Address.countryArea, Address.postalCode].filter(Boolean).join(", ")}{" "}
								{Address.country.country || Address.country}
							</div>
						</div>
						<div className="flex items-center gap-2 text-sm text-gray-600">
							<svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
								/>
							</svg>
							{Address.phone}
						</div>
					</div>
				</div>
			)}

			<div className="s-flex mb-5">
				<h3 className="text-xl font-bold !text-black">{t(shippingTitle)}</h3>
			</div>

			<form>
				<div className={clsx("w-full space-y-6")}>
					{/* First Name & Last Name */}
					<div className="space-y-6">
						{/* First Name */}
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 ${
										errors.firstName ? "text-red-400" : "text-[#85929E]"
									} left-3 bg-white text-xs`}
									htmlFor="firstName"
								>
									{t("form.f788c9b20398a5481f38c08cf68f2cb8c964")}
								</label>
								<input
									className={`w-full appearance-none rounded-md border px-5 py-3.5 ${
										errors.firstName ? "border-red-400" : "border-[#DDE6F5]"
									} focus:shadow-outline leading-tight text-gray-700 focus:shadow-lg focus:outline-none`}
									type="text"
									placeholder={t("form.f788c9b20398a5481f38c08cf68f2cb8c964")}
									id="firstName"
									{...register("firstName", {
										required: t("message.f5414f2236ca1a42db98da7c6b796fbbf035"),
									})}
								/>
							</div>
						</div>
						{/* Last Name */}
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 ${
										errors.lastName ? "text-red-400" : "text-[#85929E]"
									} left-3 bg-white text-xs`}
									htmlFor="lastName"
								>
									{t("form.2bb382a16eab9d446ac91af90ce99c3cc7f8")}
								</label>
								<input
									className={`focus:shadow-outline w-full appearance-none rounded-md border px-5 py-3.5 leading-tight text-gray-700 focus:shadow-lg focus:outline-none ${
										errors.lastName ? "border-red-400" : "border-[#DDE6F5]"
									}`}
									type="text"
									placeholder={t("form.2bb382a16eab9d446ac91af90ce99c3cc7f8")}
									id="lastName"
									{...register("lastName", {
										required: t("message.8fb4bc206b4dd947543999d66757d14712e6"),
									})}
								/>
							</div>
						</div>
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 ${
										errors.phone ? "text-red-400" : "text-[#85929E]"
									} left-3 z-10 bg-white text-xs`}
									htmlFor="phone"
								>
									{t("common.Phone")}
								</label>
								<Controller
									name="phone"
									control={control}
									rules={{
										required: t("message.6da2af7b8d5c5345f20988a3cbccd7cdfb8f"),
										validate: (value) => {
											try {
												// 如果电话号码不包含 '+' 号，添加它
												const phoneNumberWithPlus = `+${value}`;

												// 验证电话号码是否有效
												if (!isValidPhoneNumber(phoneNumberWithPlus)) {
													return t("common.invalidPhone");
												}

												// 获取电话号码的详细信息
												const phoneNumber = parsePhoneNumber(phoneNumberWithPlus);

												// 检查是否是可能的号码
												if (!phoneNumber.isPossible()) {
													return t("message.invalidPhoneLength");
												}

												return true;
											} catch (error) {
												return t("common.invalidPhone");
											}
										},
									}}
									render={({ field: { onChange, value } }) => (
										<PhoneInput
											country={"us"}
											enableSearch
											searchPlaceholder={t("common.searchCountry")}
											inputProps={{
												id: "phone",
												placeholder: t("checkout.78fb2d8b706a0d46bfb800f2d2c97e103e1e"),
											}}
											value={value}
											onChange={(phone, country: any) => {
												onChange(phone);
												// 如果需要，可以更新国家信息
												setUserShipping((prev: any) => ({
													...prev,
													countryCode: country.countryCode,
													dialCode: country.dialCode,
												}));
											}}
											containerClass={`${errors.phone ? "phone-input-error" : ""}`}
											inputStyle={{
												width: "100%",
												height: "48px", // 匹配原来的高度
												borderRadius: "0.375rem",
												borderColor: errors.phone ? "#f87171" : "#DDE6F5",
												backgroundColor: "white",
											}}
											buttonStyle={{
												borderRadius: "0.375rem 0 0 0.375rem",
												borderColor: errors.phone ? "#f87171" : "#DDE6F5",
												backgroundColor: "white",
											}}
											searchStyle={{
												width: "90%",
												margin: "0 auto",
											}}
											dropdownStyle={{
												width: "350px",
											}}
										/>
									)}
								/>
								{errors.phone && (
									<p className="mt-1 text-xs text-red-400">
										{t("message.6da2af7b8d5c5345f20988a3cbccd7cdfb8f")}
									</p>
								)}
							</div>
						</div>
					</div>

					{/* companyName name & country */}
					<div className="space-y-6">
						{/* 国家 */}
						{/* Country  */}
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 ${
										errors.country ? "text-red-400" : "text-[#85929E]"
									} left-3 bg-white text-xs`}
									htmlFor="country"
								>
									{t("checkout.eae6597b15706c40889b12521a6e903edff3")}
								</label>
								<select
									title={t("form.country")}
									className={`focus:shadow-outline w-full appearance-none rounded-md border px-5 py-3.5 leading-tight text-gray-700 focus:shadow-lg focus:outline-none ${
										errors.country ? "border-red-400" : "border-[#DDE6F5]"
									}`}
									{...register("country", {
										required: t("message.562a4f23b5987749455830dffe3b68e567e2"),
									})}
									onChange={handleChangeCountry}
								>
									<option value="">{t("checkout.861db9266e3bf743b5c84bb5b8de3b67ebcc")}</option>
									{countries.map((item, index) => (
										<option key={index} value={item.isoCode}>
											{item.isoCode} {item.name}
										</option>
									))}
								</select>
							</div>
						</div>

						{/*省 countryArea */}
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 z-[1] ${
										errors.countryArea ? "text-red-400" : "text-[#85929E]"
									} left-3 bg-white text-xs`}
									htmlFor="countryArea"
								>
									{t("checkout.1350af9875f65e46975b46c51798e07e4ec6")}
								</label>
								<select
									title={t("form.countryArea")}
									className={`focus:shadow-outline w-full appearance-none rounded-md border px-5 py-3.5 leading-tight text-gray-700 focus:shadow-lg focus:outline-none ${
										errors.countryArea ? "border-red-400" : "border-[#DDE6F5]"
									}`}
									id="countryArea"
									disabled={loading || !getFormValues("country")}
									{...register("countryArea")}
								>
									<option value="">
										{loading ? "loading..." : t("checkout.dc09d2d018ce2d462a3837538323e8b86ad8")}
									</option>
									{Array.isArray(countryArea) && countryArea.length > 0 ? (
										countryArea.map((item, index) => (
											<option key={index} value={item.verbose || item.raw}>
												{item.verbose || item.raw}
											</option>
										))
									) : getFormValues("country") && !loading ? (
										<option value="" disabled>
											{t("common.no_regions_available")}
										</option>
									) : null}
								</select>
								{loading && (
									<div className="absolute right-3 top-1/2 -translate-y-1/2">
										<RingLoader color="#4285F4" size={20} />
									</div>
								)}
							</div>
						</div>
					</div>

					{/* Town / City & District */}
					<div className="space-y-6">
						{/* Town / City */}
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 ${
										errors.city ? "text-red-400" : "text-[#85929E]"
									} left-3 bg-white text-xs`}
									htmlFor="city"
								>
									{t("checkout.db41a8b095d4e045dec8e41ee7b29f79a6e7")}
								</label>
								<input
									className={`focus:shadow-outline w-full appearance-none rounded-md border px-5 py-3.5 leading-tight text-gray-700 focus:shadow-lg focus:outline-none ${
										errors.city ? "border-red-400" : "border-[#DDE6F5]"
									}`}
									type="text"
									placeholder={t("form.City")}
									id="city"
									{...register("city", {
										required: t("message.cc6e29b38f06b64001e8e9a6a1bf81a2d3ef"),
									})}
								/>
							</div>
						</div>

						{/* Company name */}
						<div className="w-full">
							<div className="relative">
								<label
									className="absolute -top-2 left-3 bg-white text-xs text-[#85929E]"
									htmlFor="companyName"
								>
									{t("checkout.50d8b5d2a6636b442d08250ad47532b73fd5")}
								</label>
								<input
									className="focus:shadow-outline w-full appearance-none rounded-md border border-[#DDE6F5] px-5 py-3.5 leading-tight text-gray-700 focus:shadow-lg focus:outline-none"
									type="text"
									placeholder={t("form.c0b9782f9dec7d44b00be190c883b25e35f0")}
									id="companyName"
									{...register("companyName")}
								/>
							</div>
						</div>
					</div>
					{/* Street address */}
					<div className="space-y-6">
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 ${
										errors.streetAddress1 ? "text-red-400" : "text-[#85929E]"
									} left-3 bg-white text-xs`}
									htmlFor="streetAddress1"
								>
									{t("checkout.7db196092b824b40ca89655c15feadaf064e")}
								</label>
								<input
									className={`focus:shadow-outline w-full appearance-none rounded-md border px-5 py-3.5 leading-tight text-gray-700 focus:shadow-lg focus:outline-none ${
										errors.streetAddress1 ? "border-red-400" : "border-[#DDE6F5]"
									}`}
									type="text"
									placeholder={t("common.Address")}
									id="streetAddress1"
									{...register("streetAddress1", {
										required: t("message.c9183efb9d6f184d03390158cd782f83a406"),
									})}
								/>
							</div>
						</div>
						{/* Postcode / ZIP & Phone */}
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 ${
										errors.postalCode ? "text-red-400" : "text-[#85929E]"
									} left-3 bg-white text-xs`}
									htmlFor="postalCode"
								>
									{t("checkout.dc9ed9c83a3614477c18c92b64ea25203d52")}
								</label>
								<input
									className={`focus:shadow-outline w-full appearance-none rounded-md border px-5 py-3.5 leading-tight text-gray-700 focus:shadow-lg focus:outline-none ${
										errors.postalCode ? "border-red-400" : "border-[#DDE6F5]"
									}`}
									type="text"
									placeholder={t("checkout.postalCode")}
									id="postalCode"
									{...register("postalCode", {
										required: t("message.3b70d452b0ded6486e2a9f82f3db3aac0e75"),
									})}
								/>
							</div>
						</div>
					</div>

					<div className="space-y-6">
						{/* Phone */}

						{/* email*/}
						<div className="w-full">
							<div className="relative">
								<label
									className={`absolute -top-2 ${
										errors.email ? "text-red-400" : "text-[#85929E]"
									} left-3 bg-white text-xs`}
									htmlFor="email"
								>
									{t("checkout.email")}
								</label>
								<input
									className={`focus:shadow-outline w-full appearance-none rounded-md border px-5 py-3.5 leading-tight text-gray-700 focus:shadow-lg focus:outline-none ${
										errors.email ? "border-red-400" : "border-[#DDE6F5]"
									}`}
									type="text"
									placeholder={t("checkout.email")}
									id="email"
									{...register("email", {
										required: t("message.3b70d452b0ded6486e2a9f82f3db3aac0e75"),
									})}
								/>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
}
